import React, {useEffect, useState, useRef} from 'react';
import merchant from "../../network/services/merchant";
import {getCourierBusinessId} from "../../helpers/authenticator";
import quick_models from "../../network/models/quick_models";
import RidersTable from "../../components/dashboard/RidersTable";
import $ from "jquery";
import dataTables from 'datatables.net';


const CourierHome = () => {
    const [stats, setStats] = useState({});
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {

        merchant.getCourierStats(getCourierBusinessId()).then(response => {
            setStats(response.data.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })

    }, []);


    let tamperedStats = {...quick_models.merchantStatsResponse, ...stats};

    return (
        <div className="main-wrapper" style={{marginTop: 100}}>
            <div className="container">
                <div className="dashboard">
                    <div className="row justify-content-center">
                        <div className="col-md-3">
                            <div className="card text-center">
                                <ul className="list-unstyled">
                                    <li><h4>{tamperedStats.total_amount_payable}</h4></li>
                                    <li>
                                        <hr/>
                                    </li>
                                    <li>
                                        <small>Total Amount Collected (GHS)</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center">
                                <ul className="list-unstyled">
                                    <li><h4>{tamperedStats.riders}</h4></li>
                                    <li>
                                        <hr/>
                                    </li>
                                    <li>
                                        <small>Riders</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center">
                                <ul className="list-unstyled">
                                    <li><h4>{tamperedStats.orders_completed}</h4></li>
                                    <li>
                                        <hr/>
                                    </li>
                                    <li>
                                        <small>Orders Completed</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <br/>
                    <br/>

                    <div className="row justify-content-center">
                        <RidersTable/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourierHome;
